import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

const FormToggle = ({
  className = '',
  falseName = 'False',
  trueName = 'True',
  label,
  name,
  value,
  disabled = false,
  touched,
  errors,
  onChange,
  isShowLabel = true
}) => {
  const isError = touched && errors && touched[name] && errors[name];

  const handleChange = () => {
    if (!disabled) {
      onChange(value === 'true' ? 'false' : 'true');
    }
  };

  return (
    <FormGroup className={`${className} position-relative`}>
      {isShowLabel && (
        <Label htmlFor={name} className="w-100">
          {label}
        </Label>
      )}

      <div
        className={`d-inline-flex align-items-center rounded-4 switch-border ${disabled ? 'opacity-75' : 'cursor-pointer'}`}
        onClick={handleChange}>
        <input
          type="checkbox"
          id={name}
          className="visually-hidden"
          checked={value === 'true'}
          onChange={handleChange}
          disabled={disabled}
        />

        <span
          className={`py-1 rounded-4 text-nowrap ${
            value === 'true'
              ? 'bg-primary text-white fw-bold px-4'
              : 'fw-semibold text-primary px-3'
          }`}
          role="button">
          {trueName}
        </span>
        <span
          className={`py-1 rounded-4 text-nowrap ${
            value === 'false'
              ? 'bg-primary text-white fw-bold px-4'
              : 'fw-semibold text-primary px-3'
          }`}
          role="button">
          {falseName}
        </span>
      </div>

      {isError && <span className="invalid-feedback">{errors[name]}</span>}
    </FormGroup>
  );
};

// PropTypes validation
FormToggle.propTypes = {
  className: PropTypes.string,
  falseName: PropTypes.string,
  trueName: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isShowLabel: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func
};

export default FormToggle;
